import "./payment-nav.component.scoped.sass";
import React, { useState, useEffect, useContext } from "react";
import { SideNavItem } from "src/types/sidenav-item";
import { paymentNavItems } from "src/statics/sidenav-items";
import { useTranslation } from "react-i18next";
import { history } from "react-router-guard";
import { CommonService } from "src/services/common/common.service";
import { GlobalContext } from "src/store";

const NavButton = (props: any) => {
  const [t] = useTranslation();
  const { title, isActive, path } = props;

  const closeMenu = () => {
    const sidenav = document.querySelector(".main-nav");
    if (sidenav?.classList.contains('show')) {
      sidenav?.classList.remove('show')
    }
  }
  
  const navigate = (path: string) => {
    closeMenu();
    history.push(path);
  };

  return (<div onClick={navigate.bind(null, path)} className={`nav-item ${isActive ? 'active' : ''}`}>
    {t(title)}
  </div>);
}

export const PaymentNavComponent = () => {
  const [t] = useTranslation();
  const commonService: CommonService = new CommonService();
  const [activeIndex, setActiveIndex] = useState(999);
  const { clientType, client } = useContext(GlobalContext);

  const setActiveTab = () => {
    const routeName = history.location.pathname;
    paymentNavItems.forEach((item, index) => {
      const { name, title } = item;
      if (routeName.includes(name)) {
        setActiveIndex(index);
        commonService.setTitle(t(title));
      }
    });
  };

  useEffect(() => {
    setActiveTab();
    history.listen(() => {
      setActiveTab();
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="payment-nav-content">
      <div className="data">
        <div className="header">
          { t("administration") }
        </div>
        <div className="info">
          <div className="title">
            { client }
          </div>
          <div className="sub-title">
            { t(clientType) }
          </div>
        </div>
        <div className="nav-items">
          {paymentNavItems.map((item: SideNavItem, index) => <NavButton key={index} path={item.path} isActive={activeIndex === index} title={item.title}/>)}
        </div>
      </div>
    </div>
  );
};
